import { useEffect } from 'react';

export const usePreventPullToRefresh = () => {
  useEffect(() => {
    let lastTouchY = 0;
    let maybePreventPullToRefresh = false;

    const isAtTop = (): boolean => {
      return window.pageYOffset === 0 || window.scrollY === 0;
    };

    const isAtBottom = (): boolean => {
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const clientHeight = document.documentElement.clientHeight;
      return scrollTop + clientHeight >= scrollHeight - 1;
    };

    const touchstartHandler = (e: TouchEvent) => {
      if (e.touches.length !== 1) return;
      lastTouchY = e.touches[0].clientY;
      maybePreventPullToRefresh = isAtTop() || isAtBottom();
    };

    const touchmoveHandler = (e: TouchEvent) => {
      if (!maybePreventPullToRefresh || e.touches.length !== 1) return;
      
      const touchY = e.touches[0].clientY;
      const touchYDelta = touchY - lastTouchY;
      lastTouchY = touchY;
      const atTop = isAtTop();
      const atBottom = isAtBottom();
      const isPullingDown = touchYDelta > 0;
      const isPullingUp = touchYDelta < 0;
      const isSignificantMovement = Math.abs(touchYDelta) > 2;

      if (atTop && isPullingDown && isSignificantMovement) {
        e.preventDefault();
        return false;
      }

      if (atBottom && isPullingUp && isSignificantMovement) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('touchstart', touchstartHandler, { passive: true });
    document.addEventListener('touchmove', touchmoveHandler, { passive: false });

    return () => {
      document.removeEventListener('touchstart', touchstartHandler);
      document.removeEventListener('touchmove', touchmoveHandler);
    };
  }, []);
};

